module.exports = __webpack_public_path__ + "img/cmp-chevron-left.bc7cf134.svg";